module.exports = __webpack_public_path__ + "static/media/chevron-right.809a57c8.svg";